/* ==========================================================
   EXQUISITE TILE — PÁGINA DE PRODUCTO
   ----------------------------------------------------------
   (La calculadora vive sola en snippets/ex-calculator.liquid)
   2. Colores: al pasar el mouse cambia nombre y foto   [data-ex-colors]
   3. Botón "View in 3D": abre el modelo 3D de la galería
   Todo con delegación de eventos → sobrevive a recargas de
   sección de Shopify y al editor de temas.
   ========================================================== */
(function () {
  'use strict';
  if (window.ExProduct) return;

  /* ==========================================================
     2. COLORES (hover → nombre + foto principal)
     ========================================================== */
  var hoverOk = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  function mainImage() {
    // Foto activa de la galería de Trade
    return document.querySelector('.product__media-list .product__media-item.is-active img') ||
           document.querySelector('.product__media-list .product__media-item img');
  }

  function showColor(sw) {
    var box = sw.closest('[data-ex-colors]');
    var label = box && box.querySelector('[data-ex-color-name]');
    if (label) label.textContent = sw.getAttribute('data-ex-color') || label.getAttribute('data-default');
    var src = sw.getAttribute('data-ex-img');
    var img = mainImage();
    if (!src || !img) return;
    if (!img.hasAttribute('data-ex-orig-src')) {
      img.setAttribute('data-ex-orig-src', img.getAttribute('src') || '');
      img.setAttribute('data-ex-orig-srcset', img.getAttribute('srcset') || '');
    }
    img.removeAttribute('srcset');
    img.src = src;
  }

  function resetColor(box) {
    var label = box.querySelector('[data-ex-color-name]');
    if (label) label.textContent = label.getAttribute('data-default');
    document.querySelectorAll('img[data-ex-orig-src]').forEach(function (img) {
      img.src = img.getAttribute('data-ex-orig-src');
      var set = img.getAttribute('data-ex-orig-srcset');
      if (set) img.setAttribute('srcset', set);
      img.removeAttribute('data-ex-orig-src');
      img.removeAttribute('data-ex-orig-srcset');
    });
  }

  if (hoverOk) {
    document.addEventListener('mouseover', function (e) {
      var sw = e.target.closest('.ex-opt__swatch');
      if (sw) showColor(sw);
    });
    document.addEventListener('mouseout', function (e) {
      var box = e.target.closest('[data-ex-colors]');
      if (!box || box.contains(e.relatedTarget)) return;
      resetColor(box);
    });
  }
  // Teclado: al enfocar un color también se muestra
  document.addEventListener('focusin', function (e) {
    var sw = e.target.closest('.ex-opt__swatch');
    if (sw) showColor(sw);
  });
  document.addEventListener('focusout', function (e) {
    var box = e.target.closest('[data-ex-colors]');
    if (box && !box.contains(e.relatedTarget)) resetColor(box);
  });

  /* ==========================================================
     3. VIEW IN 3D
     ========================================================== */
  function open3D() {
    var model = document.querySelector('.product__media-list product-model');
    if (!model) return;
    var item = model.closest('.product__media-item');
    var id = item && item.getAttribute('data-media-id');
    // 1) Selecciona la miniatura del modelo (si existe)
    if (id) {
      var thumb = document.querySelector('.thumbnail-list__item[data-target="' + id + '"] button');
      if (thumb) thumb.click();
    }
    // 2) Lleva la vista al modelo y lo carga
    (item || model).scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () {
      if (typeof model.loadContent === 'function') model.loadContent();
    }, 250);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ex-3d]')) {
      e.preventDefault();
      open3D();
    }
  });

  window.ExProduct = { open3D: open3D };
})();